<template>
	<div
		class="status"
		:style="{ backgroundColor: lightenColor(status.backgroundColor, 20) }"
	>
		<div
			class="circle"
			:style="{ backgroundColor: status.backgroundColor }"
		></div>
		<TypographyKTypographyBody6 :color="status.fontColor">
			{{ status.name }}
		</TypographyKTypographyBody6>
	</div>
</template>

<script setup lang="ts">
	import { lightenColor } from '~/helpers/transform';

	const props = withDefaults(
		defineProps<{
			status: {
				name: string;
				backgroundColor: string;
				fontColor: string;
			};
		}>(),
		{}
	);
</script>

<style scoped lang="scss">
	.status {
		display: flex;
		gap: 4px;
		align-items: center;
		padding: 3px 4px;
		border-radius: 14px;

		.circle {
			width: 11px;
			height: 11px;
			border-radius: 50%;
		}
	}
</style>
